<template>
  <div class="about">
    <img src="@/assets/about-image.jpg" alt="About Image" class="about-image">
    <div class="about-content">
      <h2>About Me</h2>
<p>I am <strong>John McCardle, Wizard</strong></p>
<p><strong>Masters Degree in Cyberintelligence (2018)</strong> from University of South Florida</p>
<p><strong>Currently an IT Specialist at NASA</strong></p>
<p><strong>Author of "McRogueFace"</strong>, a Python/C++ game engine with an emphasis on portability. <a href="https://github.com/jmccardle/McRogueFace" target="_blank">https://github.com/jmccardle/McRogueFace</a></p>
<p><strong>Founder of "Bespoke Robot Society"</strong>, Kennedy Space Center's robotics club for adults, and the designer of SimpleBot - <a href="https://github.com/Bespoke-Robot-Society/simplebot" target="_blank">https://github.com/Bespoke-Robot-Society/simplebot</a></p>
<p><strong>President of Kennedy Space Center's Amateur Radio Club</strong> - <a href="https://www.n1ksc.org/" target="_blank">https://www.n1ksc.org/</a></p>
<p><strong>Personal blog</strong> - <a href="https://kn4obl.net/" target="_blank">https://kn4obl.net/</a></p>
<p><strong>Youtube page</strong> - <a href="https://www.youtube.com/@johnmccardle" target="_blank">https://www.youtube.com/@johnmccardle</a></p>
<p><strong>itch.io (game development) profile</strong> - <a href="https://jmccardle.itch.io/" target="_blank">https://jmccardle.itch.io/</a></p>
<p><strong>linkedin</strong> - <a href="https://www.linkedin.com/in/johnny-three-sticks/" target="_blank">https://www.linkedin.com/in/johnny-three-sticks/</a></p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AboutPage'
}
</script>

<style scoped>
.about {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px;
  color: black;
  font-family: 'Courier New', Courier, monospace;
}

.about-image {
  max-width: 100%;
  max-height: 300px;
  margin-bottom: 20px;
}

.about-content {
  max-width: 600px;
  text-align: center;
}
</style>
